import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import Loading from "../components/global/Loading";
import PlaylistThumb from "../components/Playlists/PlaylistThumb";
import PlaylistOverlay from "../components/Playlists/PlaylistOverlay";

const Playlists = (props) => {
  const {
    mixesData,
    currentPage,
    setCurrentPage,
    playlistsData,
    drawerMix,
    setDrawerMix,
    drawerOpen,
    setDrawerOpen,
    playingMix,
    setPlayingMix,
    setPlayerOpen,
  } = props;

  const [activePlaylist, setActivePlaylist] = useState(null);
  const [playlistOverlayOpen, setPlaylistOverlayOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (currentPage !== "playlists") {
      setCurrentPage("playlists");
    }
  },[]);

  if (playlistsData) {
    return (
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, transition: { duration: 0.4 } }}
        key={"playlists-wrapper"}
        className="playlist__grid-wrapper"
      >
        <PlaylistOverlay
          {...{
            mixesData,
            activePlaylist,
            setActivePlaylist,
            playlistOverlayOpen,
            setPlaylistOverlayOpen,
            drawerMix,
            setDrawerMix,
            drawerOpen,
            setDrawerOpen,
            playingMix,
            setPlayingMix,
            setPlayerOpen,
          }}
        />
        {playlistsData.map((playlist, index) => {
          return (
            <PlaylistThumb
              key={index}
              {...{
                playlist,
                setActivePlaylist,
                setPlaylistOverlayOpen,
              }}
            />
          );
        })}
      </motion.main>
    );
  } else {
    return (
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, transition: { duration: 0.4 } }}
        key={"archive-wrapper"}
        className="ra__fp-loading"
      >
        <Loading />
      </motion.main>
    );
  }
};

export default Playlists;
